import { View } from '@mairistem/planning';
import _ from 'lodash';
import isBlockFull from './isBlockFull';

/**
 * Ajoute la propriété "partiel" sur les créneaux
 * qui défini s'il reste du temps libre ou non sur le créneau
 *
 * @param {array} creneaux
 * @param {array} salles - Liste des salles pour accéder aux horaires
 * @param {View} view - La vue courante (DAY, WEEK, MONTH)
 * @returns
 */
const addPartielPropertyToCreneaux = (creneaux, salles = [], view = null) => _.map(
  creneaux,
  (creneau) => {
    // En vue DAY, tous les blocs sont pleins (non hachurés)
    if (view === View.DAY) {
      return {
        ...creneau,
        partiel: false,
      };
    }

    const { identifiantResource } = creneau;

    // Récupérer les infos de la salle
    const salle = _.find(
      salles,
      { identifiant: identifiantResource },
    );

    // Déterminer si le bloc est plein ou partiel selon la vue
    // Vue WEEK : demi-journées (isHalfDay = true)
    // Vue MONTH : journées complètes (isHalfDay = false)
    const isHalfDay = view === View.WEEK;
    const isFullBlock = isBlockFull(creneau, salle, isHalfDay);

    return {
      ...creneau,
      partiel: !isFullBlock,
    };
  },
);

export default addPartielPropertyToCreneaux;
